import { z } from 'zod';
export const UsernameSchema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^[a-z0-9._-]{3,32}$/, '3–32 characters: letters, digits, dot, dash, underscore');
export const DisplayNameSchema = z.string().trim().min(1, 'Required').max(64);
/** The upper bound keeps argon2 from becoming a denial-of-service lever. */
export const PasswordSchema = z.string().min(10, 'At least 10 characters').max(200, 'At most 200 characters');
export const RoleSchema = z.enum(['owner', 'member']);
/** The only user shape that ever leaves the server. */
export const UserSchema = z.object({
    id: z.string(),
    username: z.string(),
    displayName: z.string(),
    role: RoleSchema,
    createdAt: z.string(),
});
export const UserResponseSchema = z.object({ user: UserSchema });
/** `signupOpen`: anyone may create an account (doc 64). */
export const SetupStatusSchema = z.object({ ownerExists: z.boolean(), setupEnabled: z.boolean(), signupOpen: z.boolean().default(false) });
export const SetupRequestSchema = z.object({
    bootstrapSecret: z.string().max(512),
    username: UsernameSchema,
    displayName: DisplayNameSchema,
    password: PasswordSchema,
});
export const LoginRequestSchema = z.object({
    username: z.string().trim().toLowerCase().min(1).max(64),
    password: z.string().min(1).max(200),
});
export const ChangePasswordRequestSchema = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: PasswordSchema,
});
/** Deleting one's own account asks for the password again (doc 66). */
export const DeleteAccountRequestSchema = z.object({ password: z.string().min(1).max(200) });
//# sourceMappingURL=auth.js.map